import { UserRole } from '@cobliteam/common-types';
import useSessionStore from '@cobliteam/hooks/src/useSession/store/useSessionStore';

export interface UserPermissions {
  /** Usuário tem acesso ao grupo raiz (nenhuma restrição ou contém `0/`). */
  hasRootGroupAccess: boolean;
  /** Usuário atingiu o limite de restrições de grupo (>= 40). */
  hasMaximumGroupsRestriction: boolean;
  /** Usuário tem alguma restrição de grupo aplicada. */
  hasGroupsRestriction: boolean;
  /** Usuário é `SAFETY_COACHER` — tem UX próprio no dashboard. */
  isSafetyCoacher: boolean;
  /** Retorna `true` quando o usuário pode editar todos os grupos passados. */
  canEditAllGroups: (groupPaths: string[]) => boolean;
}

/** Derivações de permissão a partir do `session.user`. Puramente síncrono, sem fetch. */
const useUserPermissions = (): UserPermissions => {
  const user = useSessionStore((s) => s.session?.user);
  const groups = user?.groupsRestriction ?? [];
  const hasRootGroupAccess = groups.length === 0 || groups.includes('0/');
  const hasMaximumGroupsRestriction = groups.length >= 40;
  const hasGroupsRestriction = groups.length > 0;
  const isSafetyCoacher = user?.role === UserRole.SAFETY_COACHER;

  const canEditAllGroups = (groupPaths: string[]): boolean => {
    if (groupPaths.length === 0) return groups.length === 0;
    return groups.length === 0 || groupPaths.every((path) => groups.some((prefix) => path.startsWith(prefix)));
  };

  return { hasRootGroupAccess, hasMaximumGroupsRestriction, hasGroupsRestriction, isSafetyCoacher, canEditAllGroups };
};

export default useUserPermissions;
